//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex';
import constant from '~/const';
import Filters from './TableFilters.vue';

import tableConfig from './tableConfig';

export default {
  components: {
    Filters,
  },

  data() {
    return {
      tableConfig,
      constant,
    };
  },

  async mounted() {
    this.setGeneralLoader(true);
    await Promise.allSettled([
      this.loadDataAction(),
      this.loadCurrencies(),
    ]);
    this.setGeneralLoader(false);
  },

  computed: {
    ...mapState('common', ['generalLoader']),
    ...mapGetters('common', ['itemsPerPage']),

    ...mapState('cryptomatsTransactions', ['page', 'pages', 'filters', 'data']),
  },

  methods: {
    ...mapActions('common', [
      'setGeneralLoader',
      'setGeneralProgress',
      'setSuccessNotification',
      'setErrorNotification',
      'confirmAction',
    ]),
    ...mapActions('cryptomatsTransactions', {
      loadDataAction: 'loadOrders',
    }),
    ...mapActions('tradersCurrencies', {
      loadCurrencies: 'loadData',
    }),

    async loadData(data = {}) {
      this.setGeneralProgress(true);
      await this.loadDataAction(data);
      this.setGeneralProgress(false);
    },

    applyFilters() {
      const { page } = this;
      if (page > 1) {
        this.setPageAction(1);
        this.$router.replace({ query: {} });
      }

      this.loadData();
    },

    setPage(value) {
      this.setPageAction(value);

      const extendedRequestData = {
        getTotal: false,
      };

      this.loadData(extendedRequestData);
    },
  },
};
